<template>
    <svg viewBox="0 0 41 40" xmlns="http://www.w3.org/2000/svg">
        <circle :class="active ? 'fill-green' : 'fill-gray-300'" cx="20.5" cy="20" r="20" />
        <path
            class="fill-white"
            clip-rule="evenodd"
            d="M31.6001 11.7505C32.0011 12.1286 32.0417 12.7854 31.6908 13.2176L18.184 29.853C18.0082 30.0696 17.757 30.1979 17.4901 30.2075C17.2232 30.2171 16.9646 30.107 16.7758 29.9035L10.9872 23.6653C10.6104 23.2592 10.6104 22.6009 10.9872 22.1949C11.3639 21.7888 11.9748 21.7888 12.3516 22.1949L17.411 27.6473L30.2387 11.8483C30.5896 11.4161 31.1991 11.3723 31.6001 11.7505Z"
            fill-rule="evenodd"
        />
    </svg>
</template>
<script setup>
defineProps({
    active: { type: Boolean, default: false },
});
</script>
